import { useEffect, useState } from "react";
import API from "../../utils/API";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function BossApproval() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("yc_usr_dt_ls"));
    if (!u || !["BOSS", "ADMIN"].includes(u.role)) {
      navigate("/dashboard");
      return;
    }

    Swal.fire({ title: "Carregando...", showConfirmButton: false, allowOutsideClick: false, willOpen: () => Swal.showLoading() });

    const cancelToken = API.cancelToken();
    API.getPendingApprovals(cancelToken).then((res) => {
      setData(res.data || []);
      Swal.close();
    }).catch((err) => {
      if (err.message === "cancelling") return;
      Swal.close();
      Swal.fire("Erro", "Erro ao carregar aprovações pendentes.", "error");
    });

    return () => API.cancel(cancelToken);
  }, [navigate]);

  function formatDate(dateString) {
    if (!dateString) return "-";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "-";
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
  }

  const filtered = data.filter((item) => {
    const q = searchQuery.toLowerCase();
    if (!q) return true;
    return (
      String(item.service_id).includes(q) ||
      (item.license_plate || "").toLowerCase().includes(q) ||
      (item.client_name || "").toLowerCase().includes(q)
    );
  });

  return (
    <div className="flex flex-col self-stretch px-20 pt-8 pb-12 max-md:px-4">
      {/* Header */}
      <div className="flex items-center justify-between py-4 px-6 bg-white rounded-lg shadow-sm">
        <div className="flex items-center gap-3">
          <Link to="/dashboard" className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </Link>
          <h1 className="text-xl font-semibold text-gray-900">Aprovações Pendentes</h1>
          <span className="ml-2 px-2.5 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
            {filtered.length}
          </span>
        </div>
      </div>

      {/* Search */}
      <div className="mt-4 bg-white rounded-lg shadow-sm p-4">
        <input
          type="text"
          placeholder="Buscar por OS, placa ou cliente..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent"
        />
      </div>

      {/* Table */}
      <div className="mt-4 bg-white rounded-lg shadow-sm overflow-hidden">
        {filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#389E0D]" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <h2 className="text-lg font-medium text-gray-900">Nenhuma aprovação pendente</h2>
            <p className="text-gray-500 mt-1">Todas as ordens de serviço foram revisadas.</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50">
                <th className="text-left px-6 py-3 font-medium text-gray-500">OS</th>
                <th className="text-left px-6 py-3 font-medium text-gray-500">Placa</th>
                <th className="text-left px-6 py-3 font-medium text-gray-500 max-md:hidden">Veículo</th>
                <th className="text-left px-6 py-3 font-medium text-gray-500">Cliente</th>
                <th className="text-left px-6 py-3 font-medium text-gray-500 max-md:hidden">Data</th>
                <th className="text-left px-6 py-3 font-medium text-gray-500">Ação</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((item) => (
                <tr key={item.service_id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-gray-900">#{item.service_id}</td>
                  <td className="px-6 py-4 text-gray-700">{item.license_plate || "-"}</td>
                  <td className="px-6 py-4 text-gray-700 max-md:hidden">
                    {item.model ? `${item.model} ${item.year || ""}`.trim() : "-"}
                  </td>
                  <td className="px-6 py-4 text-gray-700">{item.client_name || "-"}</td>
                  <td className="px-6 py-4 text-gray-500 max-md:hidden">{formatDate(item.created_at)}</td>
                  <td className="px-6 py-4">
                    <Link
                      to={`/boss/approval/review?id=${item.service_id}`}
                      className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#389E0D] text-white text-sm font-medium hover:bg-green-700 transition-colors"
                    >
                      Revisar
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default BossApproval;
